export default __webpack_public_path__ + "static/media/Aegis of Khan.6ef78286.jpg";